<div
  [class]="data.type"
  class="snackbar-container"
  [style.gap.px]="messages.length === 1 ? 12 : 24"
>
  <ui-svg-icon [svgIcon]="getIcon(data.type)" />
  <div class="messages">
    @if (messages.length > 1) {
      <ul>
        @for (msg of messages; track msg) {
          <li>{{ msg }}</li>
        }
      </ul>
    } @else {
      <div>
        {{ messages[0] }}
        @if (remainingSeconds) {
          <span>({{ remainingSeconds }}s)</span>
        }
      </div>
    }
  </div>
  <span class="close-btn" (click)="close()">
    <ui-svg-icon svgIcon="close" size="large" />
  </span>
</div>
